var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"invoice-resolve-redirect-page"}},[_c('vs-alert',{attrs:{"color":"danger","title":_vm.$t('InvoiceGroupNotifyTitle'),"active":_vm.error},on:{"update:active":function($event){_vm.error=$event}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.error)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }